import { authorizedApi } from './index';

export const bridgeApi = authorizedApi.injectEndpoints({
  endpoints: (builder) => ({
    checkKycStatus: builder.query({
      query: () => ({
        url: `/bridge/kyc-status`,
        method: 'GET',
      }),
    }),
    createKycLink: builder.mutation({
      query: ({ email }) => ({
        url: `/bridge/kyc-link`,
        method: 'POST',
        body: {
          email,
        },
      }),
    }),
    getKycStatus: builder.query({
      query: () => ({
        url: `/bridge/kyc-status`,
        method: 'GET',
      }),
    }),
    getBridgeCustomer: builder.query({
      query: () => ({
        url: `/bridge/customer`,
        method: 'GET',
      }),
    }),
    createOnrampTransfer: builder.mutation({
      query: ({
        amount,
        payment_rail = 'wire',
        bridge_customer_id,
        currency = 'usdc',
        network = 'solana',
      }) => ({
        url: `/bridge/onramp`,
        method: 'POST',
        body: {
          amount,
          payment_rail,
          bridge_customer_id,
          currency,
          network,
        },
      }),
    }),
    createExternalAccount: builder.mutation({
      query: ({
        account_owner_name,
        account_number,
        routing_number,
        account_type,
        address,
        currency = 'usd',
        payment_rail = 'ach',
      }) => ({
        url: `/bridge/external-account`,
        method: 'POST',
        body: {
          account_owner_name,
          address,
          account_details: {
            account_type,
            account_number,
            routing_number,
          },
          currency,
          payment_rail,
        },
      }),
    }),
    createOfframpTransfer: builder.mutation({
      query: ({
        amount,
        bridge_customer_id,
        external_account_id,
        currency = 'usdc',
        network = 'solana',
      }) => ({
        url: `/bridge/offramp`,
        method: 'POST',
        body: {
          amount,
          bridge_customer_id,
          external_account_id,
          currency,
          network,
        },
      }),
    }),
    getTransferStatus: builder.query({
      query: (transferId) => ({
        url: `/bridge/transfer/${transferId}`,
        method: 'GET',
      }),
    }),
    getExternalAccounts: builder.query({
      query: () => ({
        url: `/bridge/external-accounts`,
        method: 'GET',
      }),
    }),
    getLiquidationAddresses: builder.query({
      query: () => ({
        url: `/bridge/liquidation-addresses`,
        method: 'GET',
      }),
    }),
    createLiquidationAddress: builder.mutation({
      query: ({
        external_account_id,
        chain = 'solana',
        currency = 'usdc',
      }) => ({
        url: `/bridge/liquidation-address`,
        method: 'POST',
        body: {
          external_account_id,
          chain,
          currency,
        },
      }),
    }),
    createPlaidLinkToken: builder.mutation({
      query: () => ({
        url: `/bridge/plaid-link-token`,
        method: 'POST',
      }),
    }),
    exchangePlaidPublicToken: builder.mutation({
      query: ({ link_token_id, public_token }) => ({
        url: `/bridge/plaid-exchange-token`,
        method: 'POST',
        body: {
          link_token_id,
          public_token,
        },
      }),
    }),
    handleTransferSuccess: builder.mutation({
      query: ({ transferId, transactionHash, amount, currency }) => ({
        url: `/bridge/transfer/success`,
        method: 'POST',
        body: {
          transferId,
          ...(transactionHash && { transactionHash }),
          ...(amount && { amount }),
          ...(currency && { currency }),
        },
      }),
    }),
    handleTransferError: builder.mutation({
      query: ({ transferId, errorCode, errorMessage }) => ({
        url: `/bridge/transfer/error`,
        method: 'POST',
        body: {
          transferId,
          ...(errorCode && { errorCode }),
          ...(errorMessage && { errorMessage }),
        },
      }),
    }),
    getTransferHistory: builder.query({
      query: () => ({
        url: `/bridge/transfers`,
        method: 'GET',
      }),
    }),
  }),
});

export const {
  useCheckKycStatusQuery,
  useCreateKycLinkMutation,
  useGetKycStatusQuery,
  useGetBridgeCustomerQuery,
  useCreateOnrampTransferMutation,
  useCreateExternalAccountMutation,
  useCreateOfframpTransferMutation,
  useGetTransferStatusQuery,
  useGetExternalAccountsQuery,
  useGetLiquidationAddressesQuery,
  useCreateLiquidationAddressMutation,
  useCreatePlaidLinkTokenMutation,
  useExchangePlaidPublicTokenMutation,
  useHandleTransferSuccessMutation,
  useHandleTransferErrorMutation,
  useGetTransferHistoryQuery,
} = bridgeApi;
